// extracted by mini-css-extract-plugin
export default {"addIcon":"ECMembers_addIcon__fGbgK","chips":"ECMembers_chips__att0M","bgRed":"ECMembers_bgRed__uPiLa","textWhite":"ECMembers_textWhite__75Xdf"};